import * as React from 'react';
import { withTheme } from 'styled-components';

import styled, { ITheme } from '../../theme';
import { AboutRenderer, IRenderProps } from '../../models/About';

const Header = styled.div`
  text-align: center;
`;

const ClientsDesktopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 30px;
  line-height: 1.5;
  flex-wrap: nowrap;

  @media (max-width: ${(props) => props.theme.aboutBreakpoint - 1}px) {
    gap: 0 25px;

    > * {
      width: 50%;
    }
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${(props) => props.theme.aboutBreakpoint - 1}px) {
    gap: 10px 0;
  }
`;

const column = <T extends any>(size: number, array: T[]) =>
  array.reduce((acc, item, index) => {
    const arrayIndex = index % size;

    acc[arrayIndex] =
      acc[arrayIndex] === undefined ? [item] : [...acc[arrayIndex], item];
    return acc;
  }, [] as T[][]);

type IProps = IRenderProps & {
  theme: ITheme;
};

interface IState {
  isMobile: boolean;
}

const HighlightedClients = withTheme(
  class extends React.PureComponent<IProps, IState> {
    state: IState = {
      isMobile: false,
    };

    componentDidMount() {
      this.determineMobile();
      window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    determineMobile = () => {
      const shouldBeMobile =
        window.innerWidth < this.props.theme.aboutBreakpoint;
      if (this.state.isMobile !== shouldBeMobile) {
        this.setState({ isMobile: shouldBeMobile });
      }
    };

    handleResize = () => {
      requestAnimationFrame(this.determineMobile);
    };

    render() {
      const { clients } = this.props.data.fields;
      const { isMobile } = this.state;

      return (
        <div>
          <Header>Highlighted Clients</Header>
          <ClientsDesktopContainer>
            {column(isMobile ? 2 : 3, clients).map((clientArray, index) => (
              <Column key={index}>
                {clientArray.map((client) => (
                  <div key={client}>{client}</div>
                ))}
              </Column>
            ))}
          </ClientsDesktopContainer>
        </div>
      );
    }
  }
);

export default function Wrapper() {
  return <AboutRenderer render={HighlightedClients} />;
}



// WEBPACK FOOTER //
// ./src/scenes/About/HighlightedClients.tsx